import Konva from "konva";

export type Point = { x: number; y: number };
export type Rect = { x: number; y: number; width: number; height: number };

export function toRect(bounds: Konva.RectConfig): Rect {
  return {
    x: bounds.x ?? 0,
    y: bounds.y ?? 0,
    width: bounds.width ?? 0,
    height: bounds.height ?? 0,
  };
}

export function normalizeVector(vec: Point): Point {
  const length = Math.hypot(vec.x, vec.y) || 1;
  return { x: vec.x / length, y: vec.y / length };
}

export function getFarthestExtentAlongAxis(bounds: Rect, transform: Konva.Transform, direction: Point) {
  const corners = [
    transform.point({ x: bounds.x, y: bounds.y }),
    transform.point({ x: bounds.x + bounds.width, y: bounds.y }),
    transform.point({ x: bounds.x + bounds.width, y: bounds.y + bounds.height }),
    transform.point({ x: bounds.x, y: bounds.y + bounds.height }),
  ];
  return Math.max(...corners.map((point) => direction.x * point.x + direction.y * point.y));
}

export function getNearestExtentAlongAxis(bounds: Rect, direction: Point) {
  const corners = [
    { x: bounds.x, y: bounds.y },
    { x: bounds.x + bounds.width, y: bounds.y },
    { x: bounds.x + bounds.width, y: bounds.y + bounds.height },
    { x: bounds.x, y: bounds.y + bounds.height },
  ];
  return Math.min(...corners.map((point) => direction.x * point.x + direction.y * point.y));
}

export function getWorldSpaceRight(transform: Konva.Transform, origin: Point): Point {
  const worldOrigin = transform.point(origin);
  const worldRight = transform.point({ x: origin.x + 1, y: origin.y });
  return normalizeVector({ x: worldRight.x - worldOrigin.x, y: worldRight.y - worldOrigin.y });
}
